<template>
  <div class="row">
    <div class="small-12 columns large-12">
      <div class="card balance card--bordered card--success">
        <div v-loading="loading" class="card__block">
          <div v-dompurify-html="title" class="card__header" />
          <div>
            <span v-if="!credit">
              <span class="small">
                <i class="material-icons text-warning">
                  error
                </i>
                {{ noCreditText }}
              </span>
            </span>
            <span v-else-if="!loading" class="balance__amount balance__info">
              <span>{{ currencyFormat(credit) }}</span>
              <small :class="['balance__currency', { invisible: !credit }]">
                {{ $t('RIALS') }}
              </small>
            </span>
          </div>
        </div>
        <img
          class="balance__icon"
          :src="require('@/assets/images/moneybag.svg')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { format as currencyFormat } from '@/utils/number';

export default {
  name: 'BudgetInfo',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    credit: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      required: true,
    },
    noCreditText: {
      type: String,
      required: true,
    },
  },
  methods: {
    currencyFormat,
  },
};
</script>

<style lang="scss">
.balance {
  padding: 0;
  position: relative;
  overflow: hidden;

  &__amount {
    font-size: $global-font-size * 2;
    font-weight: 700;
    margin-top: $global-margin * 0.4;
  }

  &__info {
    small {
      color: $lb-color-secondary;
      font-size: $small-font-size;
    }
  }

  &__currency {
    color: $lb-color-secondary;
    font-size: $global-font-size * 0.5;
    font-weight: normal;
    vertical-align: 2px;
  }

  &__icon {
    position: absolute;
    width: 135px;
    opacity: 0.1;
    right: -42px;
    bottom: -17px;
    z-index: 10001; // because of weird el-loading z-index ~ 100000

    @include rtl() {
      right: auto;
      left: -42px;
    }
  }

  &__loading {
    min-height: 55px !important;
    display: flex;
    align-items: center;
  }
}
</style>
